<div class="text-nowrap" [ngClass]="{'text-danger': !!errorMessage}">
  {{ displayStatus | titlecase }}
  @if (!!errorMessage) {
    <fa-icon
      class="icon"
      [icon]="['fas', 'info-circle']"
      placement="bottom"
      [ngbTooltip]="errorMessage"
      />
  }
</div>
